"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const Api = __importStar(require("@src/api"));
const elements_1 = require("@src/components/elements");
const icons_1 = require("@ant-design/icons");
const timestamp_1 = __importDefault(require("@src/components/modules/global/timestamp"));
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const react_query_1 = require("react-query");
const queries_1 = require("@src/types/queries");
const useAppQuery_1 = require("@src/hooks/useAppQuery");
const useAppMutation_1 = require("@src/hooks/useAppMutation");
function ProfileResumes() {
    const [modalWindowOpen, setModalWindowOpen] = react_1.default.useState(false);
    const [modalWindowEvent, setModalWindowEvent] = react_1.default.useState(null);
    const intl = (0, react_intl_1.useIntl)();
    const queryClient = (0, react_query_1.useQueryClient)();
    const { data: myResumes, isLoading: isFetching } = (0, useAppQuery_1.useAppQuery)(queries_1.Queries.getMyResumes, Api.Account.getMyResumes);
    const { mutateAsync: uploadResume, isLoading: isUploading } = (0, useAppMutation_1.useAppMutation)(Api.Profile.uploadResume, {
        onSuccess: () => {
            queryClient.invalidateQueries(queries_1.Queries.getMyResumes);
        },
    });
    const { mutateAsync: archiveResume, isLoading: isArchiving } = (0, useAppMutation_1.useAppMutation)(Api.Profile.archiveResume, {
        onSuccess: () => {
            queryClient.invalidateQueries(queries_1.Queries.getMyResumes);
        },
    });
    const showModal = () => {
        setModalWindowOpen(true);
    };
    const handleCancel = () => {
        setModalWindowOpen(false);
    };
    const handleOk = () => {
        archiveResume(modalWindowEvent.key);
        handleCancel();
    };
    const handleArchived = e => {
        setModalWindowEvent(e);
        showModal();
    };
    const validateImage = react_1.default.useCallback((file) => {
        if (file.size / 1024 / 1024 >= 1) {
            antd_1.notification.error({
                message: intl.formatMessage({ id: 'assets.notifications.file_too_large.title' }),
                description: intl.formatMessage({ id: 'assets.notifications.file_too_large.description' }, { filename: file.name, maxFileSizeInMb: '1' }),
            });
            return false;
        }
        return true;
    }, []);
    const isLoading = isFetching || isArchiving || isUploading;
    if (!myResumes) {
        return ((0, jsx_runtime_1.jsx)(elements_1.Panel, { className: "p-l", children: (0, jsx_runtime_1.jsx)(elements_1.Spinner, {}) }));
    }
    const resumeColumns = [
        {
            title: intl.formatMessage({
                id: 'profile.modules.resumes.table.name',
            }),
            dataIndex: 'resume_name',
            align: 'center',
            width: '45%',
        },
        {
            title: intl.formatMessage({
                id: 'profile.modules.resumes.table.date',
            }),
            dataIndex: 'created_at',
            align: 'center',
            width: '35%',
            render: val => (0, jsx_runtime_1.jsx)(timestamp_1.default, { value: val }),
        },
        {
            title: '',
            width: '20%',
            align: 'center',
            render: (val, row) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(antd_1.Dropdown.Button, { onClick: () => window.open(row.resume_url), overlay: (0, jsx_runtime_1.jsx)(antd_1.Menu, { onClick: e => handleArchived(e), children: (0, jsx_runtime_1.jsx)(antd_1.Menu.Item, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.modules.resumes.archived", defaultMessage: "Archivova\u0165" }) }, val.id) }), children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.modules.resumes.download", defaultMessage: "Stiahnu\u0165" }) }), (0, jsx_runtime_1.jsx)(antd_1.Modal, { title: intl.formatMessage({
                            id: 'profile.modules.resumes.modal.title',
                        }), visible: modalWindowOpen, onOk: () => handleOk(), onCancel: handleCancel, cancelText: intl.formatMessage({
                            id: 'profile.modules.resumes.modal.button',
                            defaultMessage: 'Zrušiť',
                        }), children: (0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.modules.resumes.modal.content" }) }) })] })),
        },
    ];
    return ((0, jsx_runtime_1.jsxs)(elements_1.Panel, { children: [(0, jsx_runtime_1.jsx)(elements_1.Table, { dataSource: myResumes.map(x => ({
                    ...x,
                    key: `resume-${x.id}`,
                })), columns: resumeColumns, bordered: true, pagination: false }), (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "p-l p-b-m", children: (0, jsx_runtime_1.jsx)(elements_1.Separator, { type: "horizontal" }) }), (0, jsx_runtime_1.jsxs)("div", { className: "flex-center flex-col", children: [(0, jsx_runtime_1.jsx)(elements_1.Link, { className: "flex-row justify-around align-center m-b-m", to: "/ucet/profil/uprava-profilu", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.modules.resumes.create", defaultMessage: "Vytvori\u0165 \u017Eivotopis" }) }) }), (0, jsx_runtime_1.jsx)(antd_1.Upload, { customRequest: e => uploadResume(e.file), showUploadList: false, beforeUpload: validateImage, disabled: isLoading, children: (0, jsx_runtime_1.jsxs)(elements_1.Button, { loading: isLoading, className: "flex-row justify-around align-center", type: "default", children: [!isLoading && (0, jsx_runtime_1.jsx)(icons_1.UploadOutlined, { className: "m-s" }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.modules.resumes.upload", defaultMessage: "Nahra\u0165 \u017Eivotopis" })] }) })] })] })] }));
}
exports.default = ProfileResumes;
